import { render, staticRenderFns } from "./OperaSJChildrenUserWindow.vue?vue&type=template&id=7f837933&scoped=true&"
import script from "./OperaSJChildrenUserWindow.vue?vue&type=script&lang=js&"
export * from "./OperaSJChildrenUserWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaSJChildrenUserWindow.vue?vue&type=style&index=0&id=7f837933&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f837933",
  null
  
)

export default component.exports